<template>
  <div class="row">
    <div class="col-12">
      <template>
        <component
          :is="component"
          :pidInfo.sync="pidInfo"
        />
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'floor-plans-elevations',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          title: '',
        }
      },
    },
  },
  data() {
    return {
      editable: true,
      pidInfo: { 
        diagramClassCd: 'FAIRD', // 건물 및 철구조물의 평면도 및 입면도 (BUILDING_CONSTRUCTION)
        title: '건물 및 철구조물의 평면도 및 입면도',
      },
      component: null,
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init() {
      this.component = () => import('@/pages/psi/pidMaster.vue');
      this.pidInfo.title = this.$comm.getLangLabel('LBL0010487'); // 건물 및 철구조물의 평면도 및 입면도
    },
    reset() {
      Object.assign(this.$data.pidInfo, this.$options.data().pidInfo);
    },
  }
};
</script>